/* eslint-disable no-else-return */
/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {formFloatInvData} from '../constants/initialFormData';
import {generateFormData} from '../utils/formUtils';
import {updateItem} from '../utils/tableUtils';

const INITIAL_STATE = {
  'loading': false,
  'loadingAdviser': false,
  'loadingClient': false,
  'loadingAll': false,
  'updateTable': false,
  'floatingInventoryData': [],
  'floatingSummaryData': [],
  'advisersList': [],
  'currentLine': {...formFloatInvData},
  'currentClient': null,
  'currentFlUserGroup': null,
  'isNotpriorizedModalOpen': false,
  'notPriorizedVehicles': [],
  'loadingNotPriorizedVehicles': false,
  'dataWasShown': false,
};

export const floatingInventory = (state, action) => {
  return createReducer(INITIAL_STATE, {

    [ActionTypes.FETCHING_NOT_PRIORIZED_VEHICLES]: (state, action) => ({
      ...state,
      'loadingNotPriorizedVehicles': true,
    }),
    [ActionTypes.FETCHED_NOT_PRIORIZED_VEHICLES]: (state, action) => ({
      ...state,
      'loadingNotPriorizedVehicles': false,
      'notPriorizedVehicles': action.response.data,
    }),
    [ActionTypes.FETCHED_NOT_PRIORIZED_VEHICLES_FAILED]: (state, action) => ({
      ...state,
      'loadingNotPriorizedVehicles': false,
      'notPriorizedVehicles': [],
    }),

    [ActionTypes.FETCHING_FLOATING_INVENTORY_SUMMARY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_SUMMARY]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingSummaryData': action.response.data,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_SUMMARY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingSummaryData': [],
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.SET_IS_NOT_PRIORIZED_MODAL_OPEN]: (state, action) => {
      return ({
        ...state,
        'isNotpriorizedModalOpen': action.payload,
      });
    },

    [ActionTypes.SET_FLOATING_DATA_WAS_SHOWN]: (state, action) => {
      return ({
        ...state,
        'dataWasShown': action.payload,
      });
    },

    [ActionTypes.FETCHING_FLOATING_INVENTORY]: (state, action) => ({
      ...state,
      'loadingAll': true,
      'dataWasShown': true,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY]: (state, action) => ({
      ...state,
      'loadingAll': false,
      'floatingInventoryData': action.response.data,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_FAILED]: (state, action) => ({
      ...state,
      'loadingAll': false,
      'floatingInventoryData': [],
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.DELETING_FLOATING_INVENTORY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_FLOATING_INVENTORY]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryData': action.response.data,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.DELETED_FLOATING_INVENTORY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryData': [],
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.FETCHING_ADVISERS_LIST]: (state, action) => ({
      ...state,
      'loadingAdviser': true,
    }),
    [ActionTypes.FETCHED_ADVISERS_LIST]: (state, action) => ({
      ...state,
      'loadingAdviser': false,
      'advisersList': action.response.data,
    }),
    [ActionTypes.FETCHED_ADVISERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingAdviser': false,
      'advisersList': [],
    }),

    [ActionTypes.FETCHING_PUT_FLOATING_INVENTORY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PUT_FLOATING_INVENTORY]: (state, action) => {
      if (action.response?.returnData) {
        const currentLine = action.response.data.find((item) => {
          return item.orderNumber === state.currentLine.orderNumber && item.line === state.currentLine.line;
        });
        return ({
          ...state,
          'loading': false,
          'floatingInventoryData': action.response.data,
          'currentLine': {
            ...(currentLine || formFloatInvData),
          },
          'currentClient': currentLine?.document || null,
          'updateTable': !state.updateTable,
        });
      } else {
        return ({
          ...state,
          'loading': false,
          'floatingInventoryData': ([
            ...updateItem(state.floatingInventoryData, action.response.data, ['orderNumber', 'line']),
          ] || state.tempOrders),
          'updateTable': !state.updateTable,
        });
      }
    },
    [ActionTypes.FETCHED_PUT_FLOATING_INVENTORY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryData': [],
    }),

    [ActionTypes.FETCHING_FLOAT_CLIENT_INFO]: (state, action) => ({
      ...state,
      'loadingClient': true,
    }),
    [ActionTypes.FETCHED_FLOAT_CLIENT_INFO]: (state, action) => {
      const businessType = state.currentLine?.businessType;
      const clientType = action?.response?.data?.clientType;
      const clientTypeUpdated =
        ((businessType === 'D' && clientType === '001') ||
        (['O', 'C'].includes(businessType) && clientType === '002') ||
        (businessType === 'P' && clientType === '005')) ? clientType : '';
      return ({
        ...state,
        'loadingClient': false,
        'currentLine': {
          ...state.currentLine,
          ...action.response.data,
          'clientType': clientTypeUpdated,
        },
        'currentClient': action.response?.data?.document,
      });
    },
    [ActionTypes.FETCHED_FLOAT_CLIENT_INFO_FAILED]: (state, action) => ({
      ...state,
      'loadingClient': false,
    }),

    [ActionTypes.SET_CURRENT_FLOATING_LINE]: (state, action) => {
      const {data, isUserTde, dealerId} = action.payload;
      const formData = generateFormData({data, isUserTde, dealerId});
      return ({
        ...state,
        'currentLine': formData,
      });
    },

    [ActionTypes.UPDATE_CURRENT_FLOATING_LINE]: (state, action) => {
      const {key, value} = action.payload;
      return ({
        ...state,
        'currentLine': {
          ...state.currentLine,
          [key]: value,
        },
      });
    },

    [ActionTypes.CLEAN_CURRENT_LINE_DATA_FLOATING]: (state, action) => {
      return ({
        ...state,
        'currentLine': {...formFloatInvData},
      });
    },
    [ActionTypes.SET_BLOCK_FLOATING_TABLE]: (state, action) => {
      return ({
        ...state,
        'blockTable': action.payload,
      });
    },
    [ActionTypes.SET_CURRENT_FLOATING_ORDER_CLIENT]: (state, action) => {
      return ({
        ...state,
        'currentClient': action.payload,
      });
    },

    [ActionTypes.SET_CURRENT_FLOATING_USER_GROUP]: (state, action) => {
      return ({
        ...state,
        'currentFlUserGroup': action.payload,
      });
    },
  })(state, action);
};
